/**
 * Cookie Handling
 */
function setCookie(name, value, hours) {
  let expires = "";
  if (hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  // Add SameSite and Secure attributes for Safari compatibility
  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax; Secure";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/**
 * Check Language Change
 */
function checkLanguageChange() {
    var language = getCookie('language');
    if (language != null) {
        if ((language == 'en' && isLanguageEn() == false) || language == 'de' && isLanguageEn()) {
            eraseCookie('_secure_session_id');
        }
    }
    if (isLanguageEn()) {
        language = 'en';
    } else {
        language = 'de';
    }
    setCookie('language', language, 14*24);
}

function getLanguage() {
    if (isLanguageEn()) {
        return 'en';
    } else {
        return 'de';
    }
}

/**
 * Countdown
 */
function countDown(countDownDate, id, removeAfterExpire, interval = null) {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0) {
        if (interval !== null) {
            clearInterval(interval);
        }
        distance = 0;
        if (removeAfterExpire == 'true') {
            document.getElementById('cd-wrapper-' + id).remove();
        }
    }
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    if (days == 1) {
        document.getElementById('label-days-' + id).innerHTML = 'Tag';
    } else {
        document.getElementById('label-days-' + id).innerHTML = 'Tage';
    }
    if (days < 10) {
        days = '0' + days;
    }
    document.getElementById('cd-days-' + id).innerHTML = days;

    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if (hours == 1) {
        document.getElementById('label-hours-' + id).innerHTML = 'Stunde';
    } else {
        document.getElementById('label-hours-' + id).innerHTML = 'Stunden';
    }
    if (hours < 10) {
        hours = '0' + hours;
    }
    document.getElementById('cd-hours-' + id).innerHTML = hours;
    
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    if (minutes == 1) {
        document.getElementById('label-minutes-' + id).innerHTML = 'Minute';
    } else {
        document.getElementById('label-minutes-' + id).innerHTML = 'Minuten';
    }
    if (minutes < 10) {
        minutes = '0' + minutes;
    }
    document.getElementById('cd-minutes-' + id).innerHTML = minutes;

    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (seconds == 1) {
        document.getElementById('label-seconds-' + id).innerHTML = 'Sekunde';
    } else {
        document.getElementById('label-seconds-' + id).innerHTML = 'Sekunden';
    }
    if (seconds < 10) {
        seconds = '0' + seconds;
    }
    document.getElementById('cd-seconds-' + id).innerHTML = seconds;
}

window.onload = function () {
    Array.prototype.forEach.call(document.getElementsByClassName('countdown-wrapper'), function(countdownWrapper) {
        var dateTime = new Date(countdownWrapper.dataset.datetime).getTime();
        var cdId = countdownWrapper.dataset.cdid;
        var removeAfterExpire = countdownWrapper.dataset.removeafterexpire;
        countDown(dateTime, cdId, removeAfterExpire);
        document.getElementById('cd-wrapper-' + cdId).style.opacity = '1';
        var interval = setInterval(function() {
            countDown(dateTime, cdId, removeAfterExpire, interval);
        }, 1000);
    });
};

/**
 * Papas little helper
 */
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function getSiblings(elem) {
	var siblings = [];
	var sibling = elem.parentNode.firstChild;
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling
	}
	return siblings;
} 

function scrollToElement(element, offset = 50, parent = window) {
    var elementPosition = element.getBoundingClientRect().top;
    var topPos = elementPosition + window.scrollY - offset;
    parent.scrollTo({
        'behavior': 'smooth',
        'left': 0,
        'top': topPos
    });
    setTimeout(() => {
        const stickyHeaderElement = document.querySelector('sticky-header');
        if (stickyHeaderElement && typeof stickyHeaderElement.hide === 'function') {
            stickyHeaderElement.hide();
        }
    }, 500);
    return false;
}

function isMobileMenuVisible() {
    return isElementVisible(document.querySelector('header-drawer'));
}

function isElementVisible(element) {
    return element.offsetParent !== null;
}

function isScrolledIntoView(elem) {
    if (!elem) return false;
    var docViewTop = window.scrollY;
    var docViewBottom = docViewTop + window.innerHeight;
    var rect = elem.getBoundingClientRect();
    var elemTop = rect.top + window.scrollY;
    var elemBottom = elemTop + rect.height;
    var ret = (elemBottom <= docViewBottom) && (elemTop >= docViewTop);
    return ret;
}

function isElementInViewport(element) {
    return new Promise((resolve) => {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.0
      };
  
      const callback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.disconnect();
            resolve(true); // Element is in view
          } else {
            resolve(false); // Element is out of view
          }
        });
      };
      const observer = new IntersectionObserver(callback, options);
      observer.observe(element);
    });
}

/**
 * Google Tag Manager
 */
function datalayer_push_cart(event, productId, productTitle, productVariant, productPrice, item_category2, productCategory = 'Apparel', qty = 1, productBrand = 'RYZON', currencyCode = 'EUR') {
    if (productPrice > 0) {
        productPrice = productPrice / 100;
    }
    var customer_id = (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '';
    dataLayer.push({ ecommerce: null });

    let eventData = {
        event: event,
        customer_id: customer_id,
        ecommerce: {
            currency: currencyCode,
            value: productPrice * qty,
            items: [{
                item_id: productId,
                item_name: productTitle,
                item_brand: productBrand,
                item_category: productCategory,
                item_category2: item_category2,
                item_variant: productVariant,
                price: productPrice,
                quantity: parseInt(qty)
            }]
        }
    };
    dataLayer.push(eventData);
}

function datalayer_push_productDetailView(eventName, productId, productTitle, productVariant, productPrice, item_category2, productCategory = 'Apparel', productBrand = 'Ryzon', currencyCode = 'EUR') {
    var customer_id = (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '';

    if (productPrice > 0) {
        productPrice = productPrice / 100;
    }

    let eventData = {
        event: eventName,
        customer_id: customer_id,
        ecommerce: {
            currency: currencyCode,
            items: [{
                item_id: productId,
                item_name: productTitle,
                item_brand: productBrand,
                item_category: productCategory,
                item_category2: item_category2,
                item_variant: productVariant,
                price: productPrice
            }]
        }
    };
    dataLayer.push(eventData);
}

function datalayer_push_changeProductOption(activeVariantIdElement, productTitle, color, size) {
    const productOptionsColors = document.querySelectorAll('.product-options--color .product-options__element');
    const productOptionsColorLength = productOptionsColors.length;

    let discountSpreadMin = 0;
    let discountSpreadMax = 0;
    for (const variant of Object.values(productDataVariants)) {
        const { productPrice, productPriceCompareAt } = variant;
        if (productPriceCompareAt != null && productPriceCompareAt > 0) {
            const discountAmount = productPriceCompareAt - productPrice;
            const discountPercent = (discountAmount / productPriceCompareAt) * 100;
            if (discountPercent < discountSpreadMin || discountSpreadMin === 0) {
                discountSpreadMin = discountPercent;
            }
            if (discountPercent > discountSpreadMax) {
                discountSpreadMax = discountPercent;
            }
        }
    }

    let discountLabelsVisible = false;
    let discountPercentDisplayed = undefined;
    productOptionsColors.forEach((productOptionsColor) => {
        const optionImageElement = productOptionsColor.querySelector('.product-options__element__image');
        const afterImageStyles = getComputedStyle(optionImageElement, '::after');
        if (afterImageStyles && afterImageStyles.content != '' && afterImageStyles.content != 'none') {
            discountLabelsVisible = true;
            if (productOptionsColor.getAttribute('data-optionraw') === color) {
                discountPercentDisplayed = parseInt(afterImageStyles.content.replace('%', '').replaceAll('"', ''));
            }
        }
    });

    const eventData = {
        event: 'pdp_variant_select',
        product_name: productTitle,
        color: color,
        size: size,
        available: undefined,
        customer_id: (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '',
        variant_id: undefined,
        variant_sku: undefined,
        price: undefined,
        compare_at_price: undefined,
        discount_amount: undefined,
        discount_percent: undefined,
        discount_percent_displayed: discountPercentDisplayed,
        on_sale: undefined,
        currency: undefined,
        discount_labels_visible: discountLabelsVisible,
        discount_spread_max: discountSpreadMax,
        discount_spread_min: discountSpreadMin,
        color_options_count: productOptionsColorLength,
        swatch_index: undefined
    };

    if (activeVariantIdElement && activeVariantIdElement.value) {
        const activeVariant = productDataVariants[activeVariantIdElement.value];
        const { productPrice, productPriceCompareAt, currencyCode } = activeVariant;

        const optionsColorsArray = Array.from(productOptionsColors);
        const activeColorOption = optionsColorsArray.find((el) => el.getAttribute('data-optionraw') === color);

        let discountAmount = 0;
        let discountPercent = 0;
        let onSale = false;
        if (productPriceCompareAt != null && productPriceCompareAt > 0) {
            discountAmount = productPriceCompareAt - productPrice;
            discountPercent = (discountAmount / productPriceCompareAt) * 100;
            onSale = discountAmount > 0;
        }

        eventData.available = activeVariant.available;
        eventData.variant_id = String(activeVariant.variantId);
        eventData.variant_sku = activeVariant.sku;
        eventData.price = productPrice / 100;
        eventData.compare_at_price = productPriceCompareAt / 100;
        eventData.discount_amount = discountAmount / 100;
        eventData.discount_percent = discountPercent;
        eventData.on_sale = onSale;
        eventData.currency = currencyCode;
        eventData.swatch_index = activeColorOption ? optionsColorsArray.indexOf(activeColorOption) : -1;
    }

    dataLayer.push(eventData);
}

function datalayer_push_notifyMe(productId, productTitle, productVariant, productPrice, item_category2, productCategory = 'Apparel', productBrand = 'Ryzon', currencyCode = 'EUR') {
    var customer_id = (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '';

    if (productPrice > 0) {
        productPrice = productPrice / 100;
    }

    let eventData = {
        event: "notify-me",
        customer_id: customer_id,
        ecommerce: {
            currency: currencyCode,
            items: [{
                item_id: productId,
                item_name: productTitle,
                item_brand: productBrand,
                item_category: productCategory,
                item_category2: item_category2,
                item_variant: productVariant,
                price: productPrice
            }]
        }
    };
    dataLayer.push(eventData);
}

function datalayer_push_wishlist(type, productId, productTitle, productVariant, productPrice, item_category2, productCategory = 'Apparel', productBrand = 'Ryzon', currencyCode = 'EUR') {
    var customer_id = (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '';

    if (productPrice > 0) {
        productPrice = productPrice / 100;
    }

    var eventType = (type === 'remove') ? 'remove_wishlist' : 'add_wishlist';
    let eventData = {
        event: eventType,
        customer_id: customer_id,
        ecommerce: {
            currency: currencyCode,
            items: [{
                item_id: productId,
                item_name: productTitle,
                item_brand: productBrand,
                item_category: productCategory,
                item_category2: item_category2,
                item_variant: productVariant,
                price: productPrice
            }]
        }
    };
    dataLayer.push(eventData);
}

function datalayer_push_begin_checkout(cartValue, cartItems, referrer = 'https://ryzon.net/cart', currency = 'EUR') {
    var customer_id = (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '';
    let eventData = {
        event: 'gtm_begin_checkout',
        customer_id: customer_id,
        referrer: referrer,
        ecommerce: {
            currency: currency,
            value: cartValue,
            items: cartItems
        }
    };
    dataLayer.push(eventData);
}

function datalayer_push_view_item_list(items, listName, listId, currencyCode = 'EUR') {
    var customer_id = (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '';
    dataLayer.push({ ecommerce: null });

    let eventData = {
        event: 'view_item_list',
        customer_id: customer_id,
        ecommerce: {
            currency: currencyCode,
            item_list_name: listName,
            item_list_id: listId,
            items: items
        }
    };
    dataLayer.push(eventData);
}

function datalayer_push_filter(event, filterName, filterValue) {
    var customer_id = (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '';
    let eventData = {
        event: event,
        customer_id: customer_id
    };
    if (filterName) {
        eventData.filter_name = filterName;
    }
    if (filterValue) {
        eventData.filter_value = filterValue;
    }
    dataLayer.push(eventData);
}

function etracker_wishlist(type, productId, productTitle, productVariant, productPrice, item_category2, productCategory = 'Apparel', productBrand = 'Ryzon', currencyCode = 'EUR') { 
    var customer_id = '';
    if (typeof ga_user_id != 'undefined' && ga_user_id != '') {
        customer_id = ga_user_id;
    }
    if (productPrice > 0) {
        productPrice = productPrice / 100;
    }

    var etracker_event = 'insertToWatchlist';
    if (type == 'remove') {
        etracker_event = 'removeFromWatchlist';
    }

    var category = [productCategory];
    if (item_category2 && item_category2 != '') {
        category.push(item_category2);
    }

    /* ETRACKER Event */
    var etrackerProduct = {
        id: productId.toString(),
        name: productTitle,
        price: (productPrice || 0).toString(),
        currency: currencyCode,
        category: category
    };
    if (typeof etCommerce != 'undefined') {
        etCommerce.sendEvent(etracker_event, etrackerProduct, 1);
    }
}

/**
 * Return Image URL with compressed size
 */
function getCompressedImgUrl(url, size) {
    var fileExtension = (/(?:\.([^.]+))?$/).exec(url)[0];
    return url.replace(fileExtension, '_' + size + fileExtension);
}
/**
 * is Touch Device?
 */
function isTouchDevice() {
    if ("ontouchstart" in document.documentElement) {
        return true;
    } else {
        return false;
    }
}

/**
 * Check if user has logged in
 */
function checkLoginEvent() {
    if (typeof ga_user_id != 'undefined' && ga_user_id != '') {
        var customer_id = ga_user_id;
        var customer_id_cookie = getCookie('customer_id');
        setCookie('customer_logged_in', 1);
        if (customer_id != customer_id_cookie) {
            setCookie('customer_id', customer_id);
            dataLayer.push({
                'event': "user_login",
                'customer_id': customer_id
            });
        }
    } else if (getCookie('customer_id') != null) {
        dataLayer.push({
            'event': "user_logout",
            'customer_id': customer_id
        });
        setCookie('customer_logged_in', '0');
        eraseCookie('customer_id');
    } else {
        setCookie('customer_logged_in', '0');
    }
}

/**
 * Copy To Clipboard
 */
function copyToClipboardRzn(text) {
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(text);
    } else {
        return new Promise((resolve, reject) => {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();

            try {
                const successful = document.execCommand('copy');
                document.body.removeChild(textarea);
                if (successful) {
                    resolve();
                } else {
                    reject(new Error('Kopieren fehlgeschlagen.'));
                }
            } catch (err) {
                document.body.removeChild(textarea);
                reject(err);
            }
        });
    }
}

/**
 * Scroll to Element
 */
document.addEventListener('click', function(event) {
    var link = event.target.closest('.scroll-link-ryzon');
    if (!link) return;
    event.preventDefault();
    var target = document.querySelector(link.getAttribute('href'));
    if (target) {
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 20, behavior: 'smooth' });
        // WCAG 2.4.3 (ID 76): scroll alone never moved focus, so keyboard/screen-reader users' reading
        // position stayed on the link while the viewport moved — move focus to the target too.
        if (!target.hasAttribute('tabindex')) {
            target.setAttribute('tabindex', '-1');
        }
        target.focus({ preventScroll: true });
    }
    setTimeout(function() {
        var stickyHeaderElement = document.querySelector('sticky-header');
        if (stickyHeaderElement && typeof stickyHeaderElement.hide === 'function') {
            stickyHeaderElement.hide();
        }
    }, 700);
});

/**
 * Filter all featured collections on sex metafields
 */
function sexFilterFeaturedCollection(activeFilter) {
    setCookie('sexFilterFeaturedCollectionUsed', new Date().getTime(), 1);
    // Set Filter
    document.querySelectorAll('.featured-collection-filter__option').forEach((option) => {
        setCookie('featured_collection_filter', activeFilter, 14*24);
        if (option.dataset.filter === activeFilter) {
            option.classList.add('active');
        } else {
            option.classList.remove('active');
        }
    });

    // Manipulate view All Links
    if (activeFilter !== 'all') {
        document.querySelectorAll('.collection__view-all a').forEach((viewAllLink) => {
            let rawLink = viewAllLink.dataset.rawlink;
            let attributeSeperator = rawLink.includes('?') ? '&' : '?';
            let attribute = 'filter.v.m.filter.gender=';
            let newLink = rawLink + attributeSeperator + attribute + activeFilter;
            viewAllLink.href = newLink;
        });
    }

    // Filter Products
    document.querySelectorAll('.featured-collection-product-list').forEach((productList) => {
        var maxProducts = productList.dataset.max;
        var visibleProducts = 0;
        productList.querySelectorAll('li').forEach((product) => {
            if (visibleProducts < maxProducts) {
                var productSex = product.dataset.sex;
                if (activeFilter === 'all') {
                    product.classList.add('show');
                    visibleProducts++;
                } else {
                    if (productSex !== activeFilter) {
                        product.classList.remove('show');
                    } else {
                        product.classList.add('show');
                        visibleProducts++;
                    }
                }
            } else {
                product.classList.remove('show');
            }
        });
    });
}

/**
 * Update Remaining Shipping Notice
 */
function updateRemainingNotice(productPrice = null) {
    const remainingShippingElement = document.querySelector('.remaining-shipping');
    const isMiniCart = remainingShippingElement.hasAttribute('data-source') && remainingShippingElement.dataset.source === 'mini-cart';
    const progressBarElement = remainingShippingElement.querySelector('.remaining-shipping__content__progress__bar');
    const remainingValueElement = remainingShippingElement.querySelector('#remaining-value');
    const treshold = 15000;

    var subtotalValue = 0;
    if (document.querySelector('.totals__subtotal-value')) {
        subtotalValue = convertPriceToFloat(document.querySelector('.totals__subtotal-value').innerHTML);
    }
    if (productPrice !== null) {
        subtotalValue = convertPriceToFloat(remainingShippingElement.dataset.carttotal) + productPrice;
    }
    const remaining = treshold - subtotalValue;

    remainingShippingElement.dataset.carttotal = subtotalValue;

    if (subtotalValue > 0) {
        remainingShippingElement.classList.remove('remaining-shipping--empty');
    } else {
        remainingShippingElement.classList.add('remaining-shipping--empty');
    }
    
    var progressBarProgress = 100;
    remainingShippingElement.classList.remove('remaining-shipping--remaining');
    remainingShippingElement.classList.add('remaining-shipping--free');
    if (remaining > 0) {
        progressBarProgress = subtotalValue * 100.0 / treshold;
        remainingShippingElement.classList.remove('remaining-shipping--free');
        remainingShippingElement.classList.add('remaining-shipping--remaining');
    }

    const currency = document.body.dataset.currency == 'EUR' ? '€' : document.body.dataset.currency;
    remainingValueElement.innerHTML = parseFloat(remaining / 100) + ' ' + currency;
    setTimeout(() => {
        progressBarElement.style.setProperty("--progressbar-width", progressBarProgress + "%");
    }, isMiniCart ? 1250 : 1000);
}

function convertPriceToFloat(priceString) {
    return parseFloat(priceString.replace(/[$€CHF]/g, '').replace(/,/g, '').replace(/(\d+)\.(\d{2})$/, '$1$2'));
}

/**
 * Check Consent for a specific service
 * @param {*} serviceName 
 * @returns 
 */
function checkConsentForService(serviceName, serviceId = null) {
    try {
        const ucDataRaw = localStorage.getItem('ucData');
        if (!ucDataRaw) return null;
        const ucData = JSON.parse(ucDataRaw);
        const services = ucData?.consent?.services;
        if (!services) return null;
        const consentService = Object.values(services).find(
            service => service.name === serviceName || (serviceId && service.id === serviceId)
        );
        return !!(consentService && consentService.consent);
    } catch (e) {
        console.error('Failed to parse ucData from localStorage', e);
        return false;
    }
}

/**
 * Get Cookie Consent Value
 * This function retrieves the value of a specific key from the CookieConsent cookie.
 * @param {string} key - The key to retrieve the value for (necessary, preferences, statistics, marketing).
 * @returns {boolean} - Returns true if the key is present and true in the cookie, false otherwise.
 */
function getCookieConsentValue(key) {
  const raw = getCookie('CookieConsent');
  if (!raw) return false;

  try {
    const decoded = decodeURIComponent(raw);
    const cleaned = decoded
      .replace(/{|}/g, '')
      .replace(/%27/g, '"')
      .split(',')
      .reduce((acc, pair) => {
        const [k, v] = pair.split(':');
        acc[k.trim()] = v === 'true';
        return acc;
      }, {});
    return !!cleaned[key];
  } catch (e) {
    return false;
  }
}

/**
 * User Focus (men / women / unisex)
 * Derived from viewed gendered PDPs and gender filters. Stored in localStorage only, so it never
 * leaves the browser – formerly the cookies ryzon_user_focus / ryzon_user_focus_history.
 * Stored as { men, women, focus, expires }, valid for 14 days after the last update.
 */
function getUserFocus() {
    const state = readUserFocusState();
    return state ? state.focus : null;
}

function readUserFocusState() {
    try {
        const state = JSON.parse(localStorage.getItem('ryzon_user_focus'));
        if (state && state.expires > Date.now()) return state;
        localStorage.removeItem('ryzon_user_focus');
    } catch (e) {}
    return migrateUserFocusCookies();
}

function writeUserFocusState(state) {
    state.expires = Date.now() + 14 * 24 * 60 * 60 * 1000; // 14 days
    try {
        localStorage.setItem('ryzon_user_focus', JSON.stringify(state));
    } catch (e) {}
}

// Takes over the counts from the former cookies once and deletes them
function migrateUserFocusCookies() {
    const history = getCookie('ryzon_user_focus_history');
    const focus = getCookie('ryzon_user_focus');
    if (!history && !focus) return null;

    setCookie('ryzon_user_focus_history', '', -1);
    setCookie('ryzon_user_focus', '', -1);
    if (!history) return null;

    const [menRaw, womenRaw] = decodeURIComponent(history).split('|');
    const state = {
        men: parseInt(menRaw?.split(':')[1], 10) || 0,
        women: parseInt(womenRaw?.split(':')[1], 10) || 0,
        focus: focus || 'unisex'
    };
    writeUserFocusState(state);
    return state;
}

/**
 * Update User Focus View
 * This function updates the user's focus view based on their interactions with the site.
 */
function updateUserFocusView(group) {
    if (!['men', 'women'].includes(group)) return;

    const previous = readUserFocusState();
    const state = {
        men: previous?.men || 0,
        women: previous?.women || 0
    };
    state[group]++;

    // set focus with ratio count 60% or more
    const total = state.men + state.women;
    state.focus = 'unisex';
    if (state.men / total >= 0.6) state.focus = 'men';
    else if (state.women / total >= 0.6) state.focus = 'women';

    // send event if changed
    if (previous?.focus !== state.focus) {
        var customer_id = (typeof ga_user_id !== 'undefined' && ga_user_id !== '') ? ga_user_id : '';
        let eventData = {
            event: 'user_focus_change',
            customer_id: customer_id,
            user_focus: state.focus
        };
        dataLayer.push(eventData);
    }

    writeUserFocusState(state);
}

/**
 * Reorder Notify Me Button
 */
function observeNotifyMeButton() {
    const target = document.querySelector('.product-form__container');
    if (target) {
        new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1) {
                        if (node.matches('.swym-button-bar.swym-isa-button-bar') ||
                            node.querySelector('.swym-button-bar.swym-isa-button-bar')) {
                            reorderNotifyMeButton('observeNotifyMeButton');
                            return;
                        }
                    }
                }
            }
        }).observe(target, { childList: true, subtree: true });
    }
}

function reorderNotifyMeButton(caller = 'unknown') {
    const notifyMeWrapper = document.querySelector('.swym-button-bar.swym-isa-button-bar');
    let buttonContainer = document.querySelector('.product-form__buttons') || document.querySelector('#addToCart.notAvailableBtn');
    if (notifyMeWrapper && buttonContainer && buttonContainer.firstElementChild !== notifyMeWrapper) {
        buttonContainer.prepend(notifyMeWrapper);
    }
}